













import {Component, Vue, Watch} from 'vue-property-decorator';
import {ModuleOrganization} from '@/store/modules/OrganizationModule';
import {ModuleShop} from '@/store/modules/ShopModule';
import OrdersChart from '@/screens/dashboard/charts/OrdersChart.vue';
import {analyticsOrdersStatus} from '@/services/AnalyticsService';

@Component({
  components: {OrdersChart},
})
export default class OrdersChartFiltration extends Vue {

  loading: boolean = false;
  series: any[] = [];
  categories: any[] = [];
  ordersAnalytics: any = [];

  get organizationId() {
    return ModuleOrganization.organizationId;
  }

  get shopId() {
    return ModuleShop.shopId;
  }

  @Watch('shopId', {immediate: true})
  async loadData() {
    try {
      this.loading = true;
      this.series = [];
      this.ordersAnalytics = await analyticsOrdersStatus(this.organizationId, this.shopId);
      this.ordersAnalytics.map((item: any) => {
        this.series.push(item.value);
        this.categories.push(item.date);
      });
    } finally {
      this.loading = false;
    }
  }
}
